/**
 * WebSocket envelope wrappers (both directions).
 * Source of truth: asyncapi.yaml
 */

import type { WsMessageType } from './messages';

/** Client → Server envelope */
export interface WsRequest<P = unknown> {
  messageType: WsMessageType;
  correlationId?: string | null;
  payload: P;
}

/** Server → Client success envelope */
export interface WsResponse<P = unknown> {
  messageType: WsMessageType;
  correlationId?: string | null;
  payload: P;
}

/** Server → Client error envelope */
export interface WsErrorResponse {
  messageType: WsMessageType;
  correlationId?: string | null;
  error: {
    code: string;
    message: string;
  };
}

/** Type guard: is this an error envelope? */
export function isWsError(msg: WsResponse | WsErrorResponse): msg is WsErrorResponse {
  return 'error' in msg && msg.error != null;
}
